import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es una dieta estricta?',
  answer: 'No. Es una estructura adaptable con regla de ajuste simple. Podés adaptarla a tu peso, objetivo y contexto sin seguir un plan rígido.'
}, {
  question: '¿Sirve si peso más o menos de 75 kg?',
  answer: 'Sí. Incluye regla ±10% clara para ajustar gramos según tu peso actual. Funciona para cualquier punto de partida.'
}, {
  question: '¿Necesito pesar todo para siempre?',
  answer: 'No. El objetivo es que internalices estructura, no depender eternamente de la balanza. Con el tiempo vas a saber calcular a ojo.'
}, {
  question: '¿Es solo para definición?',
  answer: 'No. Incluye definición, volumen limpio y ajustes avanzados. Tenés tomos específicos para cada objetivo.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'Acceso de por vida. Sin renovaciones ni pagos adicionales. Una vez que comprás, el contenido es tuyo para siempre.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-8">
      {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-9">
          <button className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-10">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-11">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-12" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" />}
          </button>

          {openIndex === index && <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-14">
              {faq.answer}
            </div>}
        </div>)}
    </div>;
}